// extracted by mini-css-extract-plugin
export default {"contenedorEventos":"MisEventos_contenedorEventos__-bInC"};